<template>
  <div class="activity202204" id="activity202204">
  	<div class="top-banner"></div>
    	<div class="body-content">
    		<div class="ctn-box">
    			<div class="price-list-box">
    				<ul class="price-list">
    					<li class="clearfix p-item" v-for="item in pricelist" :key="item.name">
    						<div class="type-box">
    							<div class="price-top-name">
    								<span class="l-name">{{item.name}}</span>
    								<span class="r-p">{{item.rprice}}</span>
    							</div>
    							<div class="pbtm-info">
    								{{item.btmdesc}}
    							</div>
    						</div>
    						<div class="price-num-info">
    							<div class="top-text">{{item.sourcename}}</div>
    							<div class="middle-text">{{item.tip}}</div>
    							<div class="btm-text">{{item.btmprice}}</div>
    						</div>
    						<div class="price-btn-box">
    							<span class="buy-btn" @click="goUrl(item.code)">立即购买</span>
    							<div class="pr-tip" v-html="item.btntip">
    								<!-- <p>{{item.sourcename}}</p>
    								<p>{{item.sourcename}}</p> -->
    							</div>
    						</div>
    					</li>
    				</ul>
    			</div>

    			<div class="clearfix border-panel middle-panel">
    				<div class="tophead-title">
    					<span v-for="(item, index) in middleData.titles" :key="index" v-html="item"></span>
    				</div>
    				<div class="l-icons-box">
    					<ul class="icon-list">
    						<li v-for="(item, index) in middleData.iconlisttext" :key="index">{{item}}</li>
    					</ul>
    				</div>
    				<div class="r-tab-box">
    					<div class="tab-box">
    						<span v-for="(item,index) in middleData.tablist.tles"  :class="{active: middleData.tablist.tlesindex==index}" @click="middleData.tablist.tlesindex = index" :key="index">{{item}}</span>
    					</div>
    					<div class="img-result">
    						<div class="img-item" :class="{active: middleData.tablist.tlesindex==0}">
    							<img src="../../assets/images/activity/activity202204/img1.png" alt="">
    						</div>
    						<div class="img-item" :class="{active: middleData.tablist.tlesindex==1}">
    							<img src="../../assets/images/activity/activity202204/img2.jpg" alt="">
    						</div>
    					</div>
    				</div>
    			</div>

    			<div class="border-panel btm-panel">
    				<div class="title">最新明星功能讲解,大智慧个股评分系统<em>（仅限策略投资终端）</em></div>
    				<div class="desc-box">
    					<p>大智慧个股评分系统，基于个股基本面、技术面、资金面等多维数据，采用归一化排序方式对其进行评分，以便于投资者从全市场、同行业、同概念等各种角度对个股进行比较，解决选股难题。</p>
  					<p>个股评分系统的归一化评价方法，从：相对强度、每股盈利、资金流向、最高价差比、平均成交量、扣非ROE(年化)、营收同比、净收益率、行业强度等多个维度的评分因子对个股进行打分和横向比较，用户可以自主定义各项评分因子权重设置综合评分，快速筛选高分个股。</p>
    					<div class="img-box">
    						<img src="../../assets/images/activity/activity202204/btmimg.jpg"/>
    					</div>
    				</div>
    			</div>
    			<div class="btm-desc-box">
    				<span>活动须知：</span>
    				<span><p>《大智慧365》、《大智慧专业版》、《大智慧财富版》、《大智慧策略投资终端》双年卡，季卡，月卡均不参与活动。</p><p>股市有风险，投资需谨慎 </p>   </span>
    			</div>
    		</div>
    	</div>
  </div>
</template>


<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
	name: 'activity202204',
  components: {
    AppHeader,
  },
  data () {
    return {
        token: '',
		pricelist:[
			{
				name:'大智慧365',
				rprice:'998元/年',
				btmdesc:'大智慧365是界面简洁，简单好用的炒股利器，助你轻松选股操作。沪深level-2、全息盘口等核心功能直击主力买卖，为您提供多种特色数据服务！软件轻量化，价格亲民化。',
				sourcename:'大智慧APP',
				tip:'沪深 LEVEL-2 手机版',
				btmprice:'58元/年',
				btntip:'<p>PC+移动L2</p><p>仅需998元/年</p>',
				code:'3047'
			},
			// {
			// 	name:'大智慧专业版',
			// 	rprice:'2680元/年',
			// 	btmdesc:'大智慧专业版是为专业投资型用户所研发的软件，提供全面的市场交易数据。可按照投资者的思路，对指标设计、公式选股、扩展数据进行深度个性化运用，建立个人专属的投资模型，决胜A股。',
			// 	sourcename:'大智慧APP',
			// 	tip:'沪深 LEVEL-2 手机版',
			// 	btmprice:'58元/年',
			// 	btntip:'<p>PC+移动L2</p><p>仅需2680元/年</p>',
			// 	code:'3048'
			// },
			// {
			// 	name:'大智慧财富版',
			// 	rprice:'9800元/年',
			// 	btmdesc:'按照国际高端金融服务标准打造，囊括各类证券市场常用分析系统，从市场行情、深度资讯、宏观行业数据等全方位出发，打造多样化决策系统，满足不同投资者的需求。',
			// 	sourcename:'大智慧APP',
			// 	tip:'沪深 LEVEL-2 手机版',
			// 	btmprice:'58元/年',
			// 	btntip:'<p>PC+移动L2</p><p>仅需9800元/年</p>',
			// 	code:'3049'
			// },
			// {
			// 	name:'大智慧策略投资终端',
			// 	rprice:'38000元/年',
			// 	btmdesc:'大智慧策略投资终端是专为高级投资者和专业机构所设计的高端金融信息服务产品，综合运用多维一体的资金分析模型、智能大数据分析系统、精选系统策略，创造投资新高度。',
			// 	sourcename:'大智慧APP',
			// 	tip:'沪深 LEVEL-2 手机版',
			// 	btmprice:'58元/年',
			// 	btntip:'<p>PC+移动L2</p><p>仅需38000元/年</p>',
			// 	code:'3050'
			// }
		],
		middleData:{
			titles:[
				'<p>大智慧沪深京行情</p><p>多种深度功能展现</p>',
				'<p>双终端同步实时千档行情</p><p>在家出门两不误</p>'
			],
			iconlisttext:['沪深京','板块题材','产业研究','联动L2行情','涨停分析','资金流向','董秘互动','选股'],
			tablist:{
				tles:['电脑端L2盘口','移动端L2盘口'],
				tlesindex:0
			}
		}
	}
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {


  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
$url:'../../assets/images/activity/activity202204/';
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
$color:#7c35ff;
body{
	background-color: #c78dff;
}

.activity202204{
  background-color: #c78dff;
	.top-banner{
		width: 100%;
		height: 650px;
		background: url($url+'bg1.jpg')no-repeat center/1960px;
	}
	.body-content{
		padding-bottom: 118px;
		.ctn-box{
			width: 1200px;
			margin: 0 auto;
			border: 4px solid #ffc663;
			box-sizing: border-box;
			padding: 46px 46px 0;
			border-radius: 20px;
			background-color: #ad73e6;
			.price-list-box{
				.price-list{
					padding-bottom: 12px;
					.p-item{
						width: 100%;
						height: 200px;
						box-shadow: 5px 0 15px #894acb;
						margin-bottom: 30px;
						background-color: #fff;
						border-radius: 20px;
						display: flex;
						padding: 30px ;
						box-sizing: border-box;
						.type-box{
							width: 516px;
							padding-right: 52px;
							box-sizing: border-box;
							.price-top-name{
								.l-name{
									font-size: 36px;
									color: $color;
									line-height: 30px;
								}
								.r-p{
									line-height: 28px;
									padding: 0 4px;
                  font-size: 18px;
									color: $color;
									border: 1px solid $color;
									border-radius: 5px;
									float: right;
								}
							}
							.pbtm-info{
								font-size: 16px;
								color: #333;
								padding-top: 45px;
							}
						}
						.price-num-info{
							position: relative;
							width: 268px;
							padding-left: 58px;
							box-sizing: border-box;
							&:before,&:after{
								content: '';
								position: absolute;
								width: 2px;
								height: 147px;
								background-color: #f5e6ff;
								top: 0;
								left: 0;
							}
							&:after{
								right: 0;
								left: auto;
							}
							.top-text{
								color: $color;
								font-size: 30px;
								line-height: 30px;
							}
							.middle-text{
								display: block;
								margin-top: 45px;
								color: #030202;
								font-size: 16px;
								line-height: 16px;
							}
							.btm-text{
								display: block;
								margin-top: 20px;
								line-height: 28px;
                font-size: 18px;
								padding: 0 4px;
								color: $color;
                box-sizing: border-box;
								border: 1px solid $color;
								border-radius: 5px;
								display: inline-block;
							}
						}
						.price-btn-box{
							padding-left: 48px;
							.buy-btn{
								width: 180px;
								height: 60px;
								border-radius: 30px;
								font-size: 30px;
								line-height: 60px;
								display: block;
                color: #fff;
                text-align: center;
                cursor: pointer;
								background: linear-gradient(to bottom,#e169ff, #8155ff);
								//e169ff   8155ff
							}
							.pr-tip{
								padding-top: 27px;
                text-align: center;
                color: $color;
                font-size: 20px;
								p {
									text-align: center;
									color: $color;
									font-size: 20px;
								}
							}
						}
					}
				}
			}
			.border-panel{
				border: 4px solid #ffc663;
				border-radius: 20px;
				box-sizing: border-box;
        background-color: #c78dff;
				&.middle-panel{
					padding-top: 40px;
					padding-bottom: 32px;
					margin-bottom: 38px;

					.tophead-title{
						background:url($url+'tlebg1.png')no-repeat center top/1200px;
						height: 143px;
            padding-left: 46px;
						span{
							display: inline-block;
              padding-top: 3px;
              width: 450px;
              font-size: 30px;
              color: $color;
              text-align: center;
              font-style: italic;
              line-height: 48px;
              padding-top: 13px;
              box-sizing: border-box;
              &:first-child{
									margin-right: 82px;
              }
							p{
								font-size: 30px;
								color: $color;
								text-align: center;
								font-style: italic;
								line-height: 38px;
							}
						}
					}
					.l-icons-box{
						padding-top: 82px;
						width: 528px;
						display: inline-block;
						float: left;
						.icon-list{
							text-align: center;
							padding-left: 8px;
							height: 526px;
							background: url($url+'icons.png')no-repeat center top/466px;
							li{
								float: left;
								font-size: 24px;
								color: #fff;
								width: 172px;
								padding-top: 117px;
								margin-bottom: 36px;
								display: inline-block;
								&:nth-child(7){
									margin-left: 82px;
								}
							}
						}
					}
					.r-tab-box{
						display: inline-block;
						width: 500px;
						float: right;
						margin-right: 28px;
						padding-top: 10px;
						.tab-box{
							width: 370px;
							height: 50px;
							border-radius: 8px;
							border: 1px solid $color;
							display: flex;
							margin: 0 auto 20px;
							span{
                cursor: pointer;
								display: inline-flex;
								width: 50%;
								font-size: 24px;
								color: $color;
								line-height: 50px;
								text-align: center;
								justify-content: center;
								&.active{
									color: #fff;
									background-color: $color;
								}
							}
						}
						.img-result{
							width: 500px;
							height: 540px;
							border-radius: 20px;
							background-color: #f9f9f9;
							.img-item{
								display: none;
								img{
									display: block;
									margin: 0 auto;
                  border-radius: 20px;
								}
								&.active{
									display: block;
								}
							}
						}
					}

        }
				&.btm-panel{
					padding-bottom: 32px;
					.title{
						font-size: 30px;
						color: $color;
						line-height: 62px;
						text-align: center;
						height: 101px;
						background: url($url+'tlebg2.png')no-repeat center top /1200px;
            em{
              font-size:18px;
            }
					}
					.desc-box{
						padding: 0 38px;
						p{
							font-size: 20px;
							color: #fff;
							text-shadow: 0 2px 4px #7740b0;

              &:first-child{
                margin-bottom: 38px;
              }
						}
						.img-box{
							max-width: 100%;
              margin-top: 30px;
							img{
								max-width: 100%;
								display: block;
								margin: 0 auto;
							}
						}
					}
				}

			}

      .btm-desc-box{
				padding: 12px 0 16px;
				text-align: center;
				display: block;
				width: 923px;
				margin: 0 auto;
				text-align: left;
				display: flex;
				span{
					color: #ecd8ff;
					font-size: 16px;
					display: inline-block;
					&:first-child{
						    white-space: nowrap;
					}
				}
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/activity/activity202204.vue